import api from "./Api";

// DEVN3-466 — plano de contas da empresa (aba "Plano de Contas" no cadastro da empresa).
export type SituacaoPlanoConta = 'ATIVAS' | 'INATIVAS' | 'TODAS';

export interface IPlanoContaEmpresa {
    id: number;
    empresaID: number;
    codigo: string;
    nome: string;
    eventoID: number;
    contaReferencial: string;
    eventoNome?: string | null;
    eventoAtivo: boolean;
    dataInicioVigencia?: string | null;
    ativo: boolean;
    dataAlteracao: string;
}

export interface IPlanoContaEmpresaPagina {
    total: number;
    itens: IPlanoContaEmpresa[];
}

export interface IPlanoContaEmpresaFiltro {
    codigo: string;
    nome: string;
    referencial: string;
    situacao: SituacaoPlanoConta;
}

export interface IPlanoContaEmpresaForm {
    codigo: string;
    nome: string;
    eventoId: number | null;
    /** yyyy-MM-dd ou vazio. */
    dataInicioVigencia: string;
}

export interface IPlanoContaEventoOpcao {
    id: number;
    contaReferencial: string;
    nome?: string | null;
}

export interface IPlanoContaHistorico {
    id: number;
    operacao: 'CRIACAO' | 'EDICAO' | 'ATIVACAO' | 'INATIVACAO';
    eventoID: number;
    contaReferencial?: string | null;
    eventoNome?: string | null;
    codigo: string;
    nome: string;
    dataInicioVigencia?: string | null;
    ativo: boolean;
    usuarioID?: number | null;
    usuarioNome?: string | null;
    data: string;
}

const base = (empresaId: number) => `empresa/${empresaId}/plano-contas`;

class PlanoContaEmpresaService {
    async listar(empresaId: number, filtro: IPlanoContaEmpresaFiltro, offset: number, limit: number): Promise<IPlanoContaEmpresaPagina> {
        const { data } = await api.get<IPlanoContaEmpresaPagina>(base(empresaId), { params: { ...filtro, offset, limit } });
        return data;
    }

    async eventos(empresaId: number): Promise<IPlanoContaEventoOpcao[]> {
        const { data } = await api.get<IPlanoContaEventoOpcao[]>(`${base(empresaId)}/eventos`);
        return data;
    }

    async criar(empresaId: number, form: IPlanoContaEmpresaForm): Promise<IPlanoContaEmpresa> {
        const { data } = await api.post<IPlanoContaEmpresa>(base(empresaId), corpo(form));
        return data;
    }

    async atualizar(empresaId: number, id: number, form: IPlanoContaEmpresaForm): Promise<IPlanoContaEmpresa> {
        const { data } = await api.put<IPlanoContaEmpresa>(`${base(empresaId)}/${id}`, corpo(form));
        return data;
    }

    async ativar(empresaId: number, id: number): Promise<IPlanoContaEmpresa> {
        const { data } = await api.post<IPlanoContaEmpresa>(`${base(empresaId)}/${id}/ativar`);
        return data;
    }

    async inativar(empresaId: number, id: number): Promise<IPlanoContaEmpresa> {
        const { data } = await api.post<IPlanoContaEmpresa>(`${base(empresaId)}/${id}/inativar`);
        return data;
    }

    async historico(empresaId: number, id: number): Promise<IPlanoContaHistorico[]> {
        const { data } = await api.get<IPlanoContaHistorico[]>(`${base(empresaId)}/${id}/historico`);
        return data;
    }
}

const corpo = (form: IPlanoContaEmpresaForm) => ({
    codigo: form.codigo,
    nome: form.nome,
    eventoId: form.eventoId,
    dataInicioVigencia: form.dataInicioVigencia || null,
});

/** "2026-01-01T00:00:00" → "01/01/2026". */
export const formatarData = (valor?: string | null): string => {
    if (!valor) return '';
    const [ano, mes, dia] = valor.substring(0, 10).split('-');
    return `${dia}/${mes}/${ano}`;
};

export default new PlanoContaEmpresaService();
